import {
  View,
  ScrollView,
  TouchableOpacity,
  StyleSheet,
  ImageBackground,
  Platform,
} from "react-native";
import React, { useEffect, useState } from "react";
import HeaderComponent from "../../components/HeaderComponent";
import { BoldTxt, H2, H6, H7 } from "../../components/TextsComponents";
import DimensionsHook from "../../hooks/DimensionsHook";
import Coaching from "./Components/coaching";
import Status from "./Components/Status";
import Score from "./Components/Score";
import GreenCards from "./Components/GreenCard";
import { colors } from "../../styles/GlobalStyle";
import FavorisSwiper from "./Components/FavorisSwiper";
import Footer from "../../components/Footer";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";
import CurrentTrailsSwiper from "../../components/swiper/CurrentTrailsSwiper";
import Spinner from "../../components/Spinner";
import FinishedSwiper from "./Components/FinishedSwiper";
import SoonModal from "../../components/modals/SoonModal";
import { setUserData } from "../../redux/Actions";
const Espace = ({ navigation }) => {
  const { isDesktop, isMobile, width } = DimensionsHook();
  const { t, i18n } = useTranslation();
  const userActivity = useSelector((state) => state.userActivity);

  const dispatch = useDispatch();
  const [loader, setLoader] = useState(true);
  const [currentTrails, setCurrentTrails] = useState([]);
  const [soonModal, setSoonModal] = useState(false);

  const getCurrentTrails = async () => {
    const TOKEN = await AsyncStorage.getItem("access_token");
    const config = {
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    };
    axios
      .get(`${process.env.CURRENT_TRAILS}?language=${i18n.language}`, config)
      .then((res) => {
        // remove finished trails from current trails
        const data = res.data.filter(
          (trail) => !userActivity.finished_trails.includes(trail.trail_code)
        );
        setCurrentTrails(data);
        setLoader(false);
      });
  };

  useEffect(() => {
    getCurrentTrails();
  }, [userActivity, i18n.language]);

  useEffect(() => {
    const unsubscribe = navigation.addListener("focus", () => {
      dispatch(setUserData());
    });

    return unsubscribe;
  }, [navigation]);

  // section Status & score & cards
  const ContainerC1 = {
    backgroundColor: colors.beige,
    width: "100%",
    alignSelf: "center",
    paddingTop: 15,
    paddingBottom: 5,
    borderRadius: 20,
    flexDirection: width <= 1300 ? "column" : "row",
    overflow: "hidden",
    alignItems: "center",
    justifyContent: "space-evenly",
    padding: !isDesktop ? 5 : 0,
    paddingBottom: !isDesktop ? 15 : 0,
  };
  const BoxA = {
    flexDirection: width >= 790 ? "row" : "column",
    width: width <= 1300 ? "100%" : "50%",
    alignItems: "center",
    justifyContent: "space-evenly",
  };
  const BoxB = {
    flexDirection: width >= 1300 ? "row" : "column",
    width: !isDesktop ? "100%" : width <= 1300 ? "100%" : "50%",
    alignItems: "center",
    justifyContent: "space-between",
    overflow: "hidden",
  };
  // section-Trails & favoris
  const Trails = {
    backgroundColor: colors.beige,
    width: "100%",
    alignSelf: "center",
    borderRadius: 20,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "stretch",
    flexDirection: width <= 1300 ? "column" : "row",
    marginTop: 20,
  };
  const TrailsContainer = {
    backgroundColor: colors.white,
    width: width <= 1300 ? `100%` : `49.5%`,
    borderRadius: 20,
    marginLeft: 5,
    paddingTop: 8,
    marginBottom: 20,
  };
  // section-Recommandation
  const swiperContainerStyle = {
    backgroundColor: colors.white,
    width: "100%",
    alignSelf: "center",

    borderRadius: 20,
    overflow: "hidden",
  };

  const ContainerRecommandation = {
    backgroundColor: colors.white,
    width: "100%",
    alignSelf: "center",
    borderRadius: 20,
    paddingBottom: 10,
    paddingHorizontal: isMobile ? 10 : 20,
  };

  return (
    <View style={styles.container}>
      <SoonModal isOpen={soonModal} setIsOpen={setSoonModal} />
      <ImageBackground
        source={require("../../assets/background.png")}
        style={{ flex: 1 }}
      >
        <ScrollView showsVerticalScrollIndicator={Platform.OS === "web"}>
          <HeaderComponent
            name={t("tab_navigation.my_space")}
            navigation={navigation}
          />
          <View style={{ marginHorizontal: "2.5%" }}>
            <H2 style={{ marginTop: 20 }}>{t("tab_navigation.my_space")}</H2>
            {/** cards section */}
            <View style={ContainerC1}>
              <View style={BoxA}>
                <Status />
                <Score />
              </View>
              <View style={BoxB}>
                <GreenCards
                  setSoonModal={setSoonModal}
                  navigation={navigation}
                />
                <Coaching navigation={navigation} setSoonModal={setSoonModal} />
              </View>
            </View>

            {/* Trails */}
            {loader ? (
              <View style={{ marginVertical: 20 }}>
                <Spinner size="large" />
              </View>
            ) : (
              currentTrails.length > 0 && (
                <CurrentTrailsSwiper
                  data={currentTrails}
                  navigation={navigation}
                  myspace={true}
                />
              )
            )}

            {/** favoris trails */}
            <View style={Trails}>
              {/** favoris trails */}
              <View style={TrailsContainer}>
                <View style={styles.row}>
                  <H6 style={{ paddingLeft: isMobile ? 10 : 20 }}>
                    {t("my_space.title2_trail")}
                  </H6>

                  <TouchableOpacity
                    onPress={() =>
                      navigation.navigate("Favoris", { type: "Trail" })
                    }
                  >
                    <BoldTxt
                      style={{
                        paddingRight: isMobile ? 10 : 20,
                      }}
                    >
                      {t("my_space.see_all")}
                    </BoldTxt>
                  </TouchableOpacity>
                </View>

                <FavorisSwiper navigation={navigation} type="Trail" />
              </View>

              {/* Favoris Ateliers */}

              <View style={TrailsContainer}>
                <View style={styles.row}>
                  <H6 style={{ paddingLeft: isMobile ? 10 : 20 }}>
                    {t("my_space.title2_workshop")}
                  </H6>

                  <TouchableOpacity
                    onPress={() =>
                      navigation.navigate("Favoris", { type: "Atelier" })
                    }
                  >
                    <BoldTxt
                      style={{
                        paddingRight: isMobile ? 10 : 20,
                      }}
                    >
                      {t("my_space.see_all")}
                    </BoldTxt>
                  </TouchableOpacity>
                </View>

                <FavorisSwiper navigation={navigation} type="Atelier" />
              </View>
            </View>
            {/* Recommandation */}

            <View style={swiperContainerStyle}>
              <View style={ContainerRecommandation}>
                <View
                  style={[styles.row, { paddingTop: 20, paddingVertical: 0 }]}
                >
                  <H6> {t("my_space.title3")}</H6>

                  <TouchableOpacity
                    onPress={() =>
                      navigation.navigate("Trails", { my_space: true })
                    }
                  >
                    {/*     <BoldTxt>{t("my_space.see_all")}</BoldTxt>*/}
                    <BoldTxt></BoldTxt>
                  </TouchableOpacity>
                </View>

                <View
                  style={{
                    height: !isDesktop ? 200 : 260,
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <H7
                    style={{
                      color: colors.grayLabel,
                      textAlign: "center",
                      padding: !isDesktop ? 5 : 0,
                    }}
                  >
                    {t("my_space.recommandation_soon1")}
                    {"\n"}
                    {t("my_space.recommandation_soon2")}
                  </H7>
                </View>
              </View>
            </View>
            {/** finished contents */}

            <FinishedSwiper navigation={navigation} />
          </View>
          <View style={{ height: 30 }} />
          {isDesktop && <Footer />}
        </ScrollView>
      </ImageBackground>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: colors.beige,
    flex: 1,
  },

  row: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingVertical: 10,
  },
});

export default Espace;
